import React from 'react';
import Page from './Page';
import DataBooks from './API_Books';

const __Books = () => (
  <div className="content">
    <h1>Books</h1>
    <p className="subtitle">On this page you can find portfolio of all books was made by me. Some of them are ready to find new owner. So go ahead, find the "SALES" label or simply click button below to filter all available books.</p>
    <section>
      <ul className="pages">
        {
          DataBooks.all().map(p => (
            <Page key={p.number} type={p.type} id={p.name} class={p.label} title={p.name} descr={p.descr} img={p.img}/>
          ))
        }
      </ul>
    </section>
  </div>
)

export default __Books;



// WEBPACK FOOTER //
// ./src/components/__Books.js